import { apiDelete, apiDownload, apiGet, apiPost, apiPut, API_URI } from 'api';
import { ClipType } from 'types';
import { ReportRequestType, ReportType, ScheduledReportType, ScheduleType } from 'types/report';

const report = {
    // GET
    get: async (reportId: number) => {
        const data = await apiGet(`${API_URI}/api/report/${reportId}`);
        return data;
    },
    getClientReports: async (clientId: number) => {
        const data = await apiGet(`${API_URI}/api/report/client/${clientId}`);
        return data;
    },
    getAll: async () => {
        const data = await apiGet(`${API_URI}/api/report/all`);
        return data;
    },
    getLogClient: async (clientId: number) => {
        const data = await apiGet(`${API_URI}/api/report/log/client/${clientId}`);
        return data;
    },
    getLogProject: async (projectId: number) => {
        const data = await apiGet(`${API_URI}/api/report/log/project/${projectId}`);
        return data;
    },
    getLogContact: async (contactId: number) => {
        const data = await apiGet(`${API_URI}/api/report/log/contact/${contactId}`);
        return data;
    },
    getLogAll: async () => {
        const data = await apiGet(`${API_URI}/api/report/log/all`);
        return data;
    },
    download: async (reportGuid: string, fileFormat: string) => {
        const data = await apiDownload(`${API_URI}/api/report/download/${reportGuid}`, fileFormat);
        return data;
    },
    getScheduleClient: async (clientId: number) => {
        const data = await apiGet(`${API_URI}/api/report/schedule/${clientId}`);
        return data;
    },
    getScheduleAll: async () => {
        const data = await apiGet(`${API_URI}/api/report/schedule/all`);
        return data;
    },
    getSubscribedAlerts: async () => {
        const data = await apiGet(`${API_URI}/api/report/contact/notifications`);
        return data;
    },
    removeSubscription: async (reportId:number, reportType: number) => {
        const data = await apiDelete(`${API_URI}/api/report/contact/notification/unsubscribe?reportId=${reportId}&reportType=${reportType}`);
        return data;
    },
    // getTemplates: async () => {
    //     const data = await apiGet(`${API_URI}/api/report/templates`);
    //     return data;
    // },
    getReportOptions: async () => {
        const data = await apiGet(`${API_URI}/api/report/options/all`);
        return data;
    },
    // POST
    create: async (request: ReportType) => {
        const data = await apiPost(`${API_URI}/api/report/create`, request);
        return data;
    },
    generate: async (request: ReportRequestType) => {
        const data = await apiPost(`${API_URI}/api/report/generate`, request);
        return data;
    },
    generateListing: async (clips: ClipType[]) => { // OLD
        const data = await apiPost(`${API_URI}/api/report/listing/generate`, clips);
        return data;
    },
    regenerate: async (reportGuid: string) => {
        const data = await apiPost(`${API_URI}/api/report/regenerate/${reportGuid}`);
        return data;
    },
    schedule: async (request: ScheduleType) => {
        const data = await apiPost(`${API_URI}/api/report/schedule`, request);
        return data;
    },
    send: async (reportGuid: string) => {
        const data = await apiPost(`${API_URI}/api/report/send/${reportGuid}`);
        return data;
    },
    // PUT
    updateSchedule: async (request: ScheduledReportType) => {
        const data = await apiPut(`${API_URI}/api/report/schedule/update`, request);
        return data;
    },
    // DELETE
    delete: async (id: number) => {
        const data = await apiDelete(`${API_URI}/api/report/${id}`);
        return data;
    },
    deleteRequest: async (guid: string) => {
        const data = await apiDelete(`${API_URI}/api/report/log/${guid}`);
        return data;
    },
    deleteSchedule: async (id: number) => {
        const data = await apiDelete(`${API_URI}/api/report/schedule/${id}`);
        return data;
    }
}

export default report;